import axios from "axios";
import { configRefs } from "@utils/constants";
import { gGateway } from "@utils/gateway";
//#region src/request.get-user-identity.e-key.ts
/**
* fetch all data required to describe E-key users according to our internal
* UserModel representation
*/
async function getEkeyUserData(userId) {
	var _await$configRefs$api;
	const response = await axios.get(gGateway(`${(_await$configRefs$api = await configRefs.apis.gas.get()) === null || _await$configRefs$api === void 0 ? void 0 : _await$configRefs$api.replaceAll("{{version}}", "v")}/api/User/GetEkeyUserDetailsByEmail?userEmail=${encodeURIComponent(userId)}`));
	return {
		id: userId,
		name: `${response.data.FirstName} ${response.data.LastName}`,
		role: "teacher",
		authenticationProvider: "ekey"
	};
}
//#endregion
export { getEkeyUserData };

//# sourceMappingURL=request.get-user-identity.e-key.js.map